import P from '../pages';
import FormHeader from './FormHeader';
import Alert from './Alert';
import ReactMarkdown from 'react-markdown';
import { defaultMessages } from '../../../libs/i18n/default';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import FormControl from 'react-bootstrap/lib/FormControl';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import CheckboxOrRadioGroup from './CheckboxOrRadioGroup';
import { CustomFormGroup, Form } from '../../../shared/components';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { pageValid, fieldsToValidate } from '../../../shared/validator';
import { guestProfileSubmit } from '../actions';
import withDefaults from './withDefaults'
import { changeState, handleSelection } from '../../../shared/utilities';
import { generateProfileElementObject, setProfileElementsFromState } from '../../../shared/profileElementHelpers';
import UploadPhoto from './UploadPhoto'
import { snakeCase } from 'lodash'

const PersonalityProfile = ({ content, dispatch, page, user, environment, intl: { formatMessage } }) => {
  const thisPage = P.PERSONALITY_PROFILE_PAGE;
  const [submitted, setSubmitted] = useState(false)
  const hostRelationshipSelections = useSelector(state => state.localProfileElements.elements.personal.host_relationship_selections)
  const personalitySelections = useSelector(state => state.localProfileElements.elements.personal.personality_selections)

  const hostRelationshipOptions = hostRelationshipSelections.map(t => (
    content.pages.personality_profile.host_relationship_options &&
    [<ReactMarkdown className="product-explanation" source={content.pages.personality_profile.host_relationship_options[snakeCase(t[0])]} />, t[1]]
  ))
  const [photos, setPhotos] = useState(user.guest.photos || {})
  const [fields, setFields] = useState({
    personality: generateProfileElementObject([], 'personal', 'personality'),
    personalityOther: {
      val: setProfileElementsFromState('', 'personal', 'personality_other'),
      validationKey: 'profile_elements_personal_personality_other',
      profileElement: 'personality',
      dependentObj: 'personality',
      dependencyMet: (dependentObj = fieldsRef.current.personality) => {return(dependentObj.val.includes('Other'))}
    },
    publicProfile: generateProfileElementObject('', 'placement', 'public_profile'),
    hostRelationship: generateProfileElementObject('', 'personal', 'host_relationship'),
    photos: {
      val: user.guest.photos.filter(p => p.kind == 'personal'),
      validationKey: 'attributes_photos',
      validationLabel: '. You must provide at least one "Personal" photo to continue',
      profileElement: true
    }
  })
  const fieldsRef = useRef(fields)
  fieldsRef.current = fields

  useEffect(() => {
    fieldsToValidate(fields).forEach(f => {
      handleChange(f, fields[f].val, false)
    })
  }, [])

  useEffect(() => {
    handleChange('photos', user.guest.photos.filter(p => p.kind == 'personal'))
  }, [user.guest.photos])

  const handleChange = (key, val, resetDependentObject = true) => {
    changeState(
      fieldsRef.current,
      key,
      val,
      (newObj) => {
        setFields(prevFields => ({...prevFields, ...newObj}))
      },
      resetDependentObject
    )
  }

  const submit = (e) => {
    e.preventDefault()
    setSubmitted(true)
    dispatch(guestProfileSubmit({
      personal: {
        personality: fields.personality.val,
        personality_other: fields.personalityOther.val,
        host_relationship: fields.hostRelationship.val,
      },
      placement: {
        public_profile: fields.publicProfile.val
      }
    }, thisPage))
  }

  return (
    <Form page={page} thisPage={thisPage} back={true} skip={environment != 'production'} submitFunc={submit} disableSubmit={!pageValid(fields) || submitted} >
      <FormHeader title={content.pages.personality_profile.title} />

      <CustomFormGroup field={fields.hostRelationship} className="product-checkbox">
        <ControlLabel htmlFor="hostRelationship">{formatMessage(defaultMessages.clientGuestPagesPersonalityProfileLabelsHostRelationship)}</ControlLabel>
        <CheckboxOrRadioGroup
          setName={'hostRelationship'}
          type={'radio'}
          checkBoxStyle={'radio'}
          controlFunc={(e) => handleChange('hostRelationship', e.target.value)}
          options={hostRelationshipOptions}
          selectedOptions={[fields.hostRelationship.val]}/>
      </CustomFormGroup>

      <CustomFormGroup field={fields.personality}>
        <ControlLabel htmlFor="personality">{formatMessage(defaultMessages.clientGuestPagesPersonalityProfileLabelsPersonality)}</ControlLabel>
        <CheckboxOrRadioGroup
          setName={'personality'}
          type={'checkbox'}
          checkBoxStyle={'checkbox-inline-flex'}
          controlFunc={e => handleChange('personality', handleSelection(fields.personality.val, e.target.value))}
          options={personalitySelections}
          selectedOptions={fields.personality.val}/>
      </CustomFormGroup>

      <CustomFormGroup field={fields.personalityOther}>
        <ControlLabel htmlFor="personalityOther">{formatMessage(defaultMessages.clientCommonOther)}</ControlLabel>
        <FormControl id="personalityOther"
          data-testid="personalityOther"
          type="text"
          componentClass="input"
          defaultValue={fields.personalityOther.val}
          onChange={(e) => handleChange(e.target.id, e.target.value)}/>
      </CustomFormGroup>

      <CustomFormGroup field={fields.publicProfile}>
        <ControlLabel htmlFor="publicProfile">{formatMessage(defaultMessages.clientGuestPagesPersonalityProfileLabelsPublicProfile)}</ControlLabel>
        <FormControl id="publicProfile"
          type="text"
          componentClass="textarea"
          defaultValue={fields.publicProfile.val}
          onChange={e => handleChange(e.target.id, e.target.value)} />
      </CustomFormGroup>

      <CustomFormGroup field={fields.photos}>
        <ControlLabel>{formatMessage(defaultMessages.clientGuestPagesPersonalityProfileLabelsPhotos)}</ControlLabel>
        <br />
        <UploadPhoto />
        <Alert alert={formatMessage(defaultMessages.clientGuestPagesPersonalityProfileLabelsAlert)} />
        <div className='guest-photo-list'>
          { user.guest.photos.map(p => <UploadPhoto key={p.id} photo={p}/>) }
        </div>
      </CustomFormGroup>
    </Form>
  )
}

export default withDefaults(PersonalityProfile)
